import { render, staticRenderFns } from "./TopTwenty.vue?vue&type=template&id=a980afae"
import script from "./TopTwenty.vue?vue&type=script&lang=js"
export * from "./TopTwenty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports